
import RaisedButton from 'material-ui/RaisedButton';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { TextColor } from '../../../constants/generals';
import './formComponents.scss';

export interface FormFooterProps extends RouteComponentProps<any> {
    submitLabel?: string;
    cancelLabel?: string;
    onSubmit?: () => void;
    onCancel?: () => void;
    pathName?: string;
}

export class FormFooterImpl extends React.PureComponent<FormFooterProps, {}> {
    constructor(props: FormFooterProps) {
        super(props);
    }

    public handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.props.history.goBack();
    }

    public render() {
        return <div className="form-footer" >
            <RaisedButton
                className="cancel-button"
                label={this.props.cancelLabel || 'Cancel'}
                primary={true}
                onClick={this.handleCancel}
            />
            <RaisedButton
                type="submit"
                style={submitStyle}
                className="submit-button"
                label={this.props.submitLabel || 'Submit'}
                primary={true}
            />
        </div >;
    }

}
export const FormFooter = withRouter(FormFooterImpl);

const submitStyle: React.CSSProperties = {
    backgroundColor: TextColor
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/FormFooter.tsx